export const createAction = (type: any) => (payload?: any) => ({
  type,
  $payload: payload || {},
});
